<template>
  <div class="dashboard-body-futuristic">
    <!-- Header Component -->


    <!-- Main Container -->
    <main class="futuristic-container" style="flex-direction: column; padding: 1rem 2rem;">

      <!-- Main Content (PDF View) -->
      <section class="dashboard-card-futuristic dashboard-card-scrollable" style="width: 100%;">
        <div class="pdf-viewer-wrapper">

          <Teleport to="#page-action-bar">
            <button class="btn-viewer-action btn-back" @click="fileListingPage">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
              Back
            </button>
            <h1 class="page-bar-title">Eligibility Criteria</h1>
            <div class="page-bar-actions">
              <!-- <button class="btn-viewer-action" @click="exportToPDF">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
                Download PDF
              </button> -->
              <button class="btn-viewer-action btn-download" @click="downloadEligibilityCriteriaPdf"
                :disabled="downloadingPdf">
                <svg v-if="!downloadingPdf" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                <svg v-else class="spin" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                {{ downloadingPdf ? 'Downloading…' : 'Download PDF' }}
              </button>
            </div>
          </Teleport>

          <!-- Wrapper for PDF Export to include headers -->
          <div ref="documentToExport" style="background-color: white; padding: 1rem;">
            <!-- Project Details Headings -->
            <div class="project-details-bar"
              style="display: flex; gap: 3rem; padding: 1.5rem 2rem; background: rgba(15, 76, 129, 0.05); border-bottom: 1px solid #e2e8f0; margin-bottom: 1rem;">
              <div>
                <p style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.3rem;">Name Of Work</p>
                <strong style="color: #0f4c81; font-size: 1.1rem;">{{ projectDetails.name_of_work }}</strong>
              </div>
              <div>
                <p style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.3rem;">Client Name</p>
                <strong style="color: #334155; font-size: 1.1rem;">{{ projectDetails.client_name }}</strong>
              </div>
              <div>
                <p style="font-size: 0.85rem; color: #64748b; margin-bottom: 0.3rem;">Estimated Cost Crs.</p>
                <strong style="color: #334155; font-size: 1.1rem;">{{ projectDetails.estimated_cost }}</strong>
              </div>
            </div>

            <div class="pdf-content-container" style="overflow: visible; width: 100%;">
              <table class="pdf-content-table" style="table-layout: fixed; width: 100%; word-wrap: break-word;">
                <thead>
                  <tr>
                    <th style="width: 8%;">Clause No.</th>
                    <th style="width: 12%;">Factor</th>
                    <th style="width: 35%;">Requirement</th>
                    <th style="width: 10%;">All Partners Combined (JV Requirement)</th>
                    <th style="width: 15%;">Each Partner (JV Requirement %)</th>
                    <th style="width: 10%;">Lead Partner (JV Requirement %)</th>
                    <th style="width: 10%;">QR STATUS / Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  
                    <tr class="category-header-row">
                      <td colspan="7" align="left"
                        style="background-color: #fef08a; font-weight: 600; color: #854d0e; padding: 0.75rem 1rem;">
                        Technical Eligibility Criteria
                      </td>
                    </tr>
                    <tr v-for="item in technicalTableDataList" :key="item.id">
                      <td><div class="cell-scroll">{{ item.clause_no }}</div></td>
                      <td><div class="cell-scroll"></div></td>
                      <td><div class="cell-scroll">{{ item.term_condition }}</div></td>
                      <td><div class="cell-scroll">{{ item.jv_all_partners_combined }}</div></td>
                      <td><div class="cell-scroll">{{ item.jv_each_partner }}</div></td>
                      <td><div class="cell-scroll">{{ item.jv_lead_partner }}</div></td>
                      <td><div class="cell-scroll"></div></td>
                    </tr>

                    <tr class="category-header-row">
                      <td colspan="7" align="left"
                        style="background-color: #fef08a; font-weight: 600; color: #854d0e; padding: 0.75rem 1rem;">
                        Financial Eligibility Criteria
                      </td>
                    </tr>
                    <tr v-for="item in financialTableDataList" :key="item.id">
                      <td><div class="cell-scroll">{{ item.clause_no }}</div></td>
                      <td><div class="cell-scroll"></div></td>
                      <td><div class="cell-scroll">{{ item.term_condition }}</div></td>
                      <td><div class="cell-scroll">{{ item.jv_all_partners_combined }}</div></td>
                      <td><div class="cell-scroll">{{ item.jv_each_partner }}</div></td>
                      <td><div class="cell-scroll">{{ item.jv_lead_partner }}</div></td>
                      <td><div class="cell-scroll"></div></td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div> <!-- End of PDF export wrapper -->

        </div>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import { notify } from '@/utils/notify';




export default {
  name: "EligibilityCriteria",
  components: {},

  data() {
    return {
      tableDataList: [],
      technicalTableDataList: [],
      financialTableDataList: [],
      downloadingPdf: false,
      projectDetails: {
        name_of_work: 'Loading...',
        client_name: 'Loading...',
        estimated_cost: 'Loading...'
      }
    };
  },

  props: {
    getAccessToken: Function,
  },

  computed: {
    groupedTableData() {
      const groups = {};
      this.tableDataList.forEach(row => {
        const cat = row.category || 'Other';
        if (!groups[cat]) {
          groups[cat] = [];
        }
        groups[cat].push(row);
      });
      return groups;
    }
  },

  created() {
    // Hide global header for this page too
  },

  mounted() {
    this.populateCriteriaData();
  },

  methods: {

    exportToPDF: function () {
      if (this.$refs.documentToExport) {
        const el = this.$refs.documentToExport;

        // Temporarily apply compact styles for PDF
        el.style.fontSize = '8px';
        el.style.lineHeight = '1.2';

        // Shrink all td/th padding
        const cells = el.querySelectorAll('td, th');
        cells.forEach(cell => {
          cell.dataset.origPadding = cell.style.padding;
          cell.style.padding = '2px 4px';
        });

        // Shrink project details bar
        const detailsBar = el.querySelector('.project-details-bar');
        if (detailsBar) {
          detailsBar.dataset.origPadding = detailsBar.style.padding;
          detailsBar.style.padding = '6px 10px';
          detailsBar.style.gap = '1.5rem';
          detailsBar.style.marginBottom = '4px';
        }

        html2pdf().set({
          margin: 0.15,
          filename: "Eligibility_Criteria.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true, scrollX: 0, scrollY: 0, windowWidth: 1100 },
          jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
        }).from(el).save().then(() => {
          // Restore original styles
          el.style.fontSize = '';
          el.style.lineHeight = '';
          cells.forEach(cell => {
            cell.style.padding = cell.dataset.origPadding || '';
          });
          if (detailsBar) {
            detailsBar.style.padding = detailsBar.dataset.origPadding || '';
            detailsBar.style.gap = '';
            detailsBar.style.marginBottom = '';
          }
        });
      }
    },

    fileUploadPage: function () {
      this.$router.push({ name: 'Home' });
    },
    // Back to the bid's Analysis tab; carry status/from so the sidebar keeps its highlight.
    fileListingPage: function () {
      const { status, from } = this.$route.query;
      this.$router.push({
        name: 'BidDetails',
        params: { pdf_id: this.$route.params.pdf_id },
        query: { tab: 'analysis', ...(status ? { status } : {}), ...(from ? { from } : {}) },
      });
    },


    // Server-side template-styled PDF (logic lives in bid_managment; here we
    // only call the API and stream the file back).
    async downloadEligibilityCriteriaPdf() {
      if (this.downloadingPdf) return;
      this.downloadingPdf = true;
      try {
        const pdf_id = this.$route.params.pdf_id;
        const res = await axios.get(this.$API_URL + "/company_admin/download/eligibility-pdf?pdf_id=" + pdf_id, {
          responseType: 'blob',
          headers: { Authorization: 'Bearer ' + this.getAccessToken() },
        });

        let filename = 'Eligibility_Criteria.pdf';
        const disp = res.headers['content-disposition'] || res.headers['Content-Disposition'];
        if (disp) {
          const m = disp.match(/filename\*?=(?:UTF-8''|")?([^;"\n]+)/i);
          if (m && m[1]) filename = decodeURIComponent(m[1].replace(/['"]/g, ''));
        }

        const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          setTimeout(() => URL.revokeObjectURL(url), 100);
        }
      } catch (err) {
        console.error('PDF download failed', err);
        notify.error('Couldn’t download the PDF. Check your connection and try again.');
      } finally {
        this.downloadingPdf = false;
      }
    },

    populateCriteriaData: function () {
      const pdf_id = this.$route.params.pdf_id; // Get ID from route parameters

      if (!pdf_id) return; // Guard clause

      axios.get(this.$API_URL + `/company_admin/pdf-eligibility-details?pdf_id=${pdf_id}`, {
        headers: {
          Authorization: "Bearer " + this.getAccessToken()
        }
      })
        .then(res => {
          this.technicalTableDataList = res.data.items.Technical; // backend ka table JSON
          this.financialTableDataList = res.data.items.Financial; // backend ka table JSON
          if (res.data.project_details) {
            this.projectDetails = res.data.project_details;
          }
        })
        .catch(err => console.error(err));
    }
  }

};
</script>

<style scoped>
/* Removed legacy styles, now using global main.css */

.pdf-content-table td,
.pdf-content-table th {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.spin {
  animation: elig-spin 1s linear infinite;
}

@keyframes elig-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
